module.exports = __webpack_public_path__ + "img/logo_circulo.b9e1fee2.png";